if ( typeof arhikadAjax !== 'undefined' ) {
	document.querySelectorAll( '.load-more-btn' ).forEach( ( btn ) => {
		btn.addEventListener( 'click', async () => {
			const block     = btn.closest( '.projects-block' );
			const container = block.querySelector( '[data-load-more-container]' );
			const nextPage  = parseInt( btn.dataset.page, 10 ) + 1;
			const perPage   = parseInt( btn.dataset.perPage, 10 );
			const total     = parseInt( btn.dataset.totalPages, 10 );
			const label     = btn.textContent;

			btn.disabled    = true;
			btn.textContent = '…';

			const body = new FormData();
			body.append( 'action',   'load_more_projects' );
			body.append( 'nonce',    arhikadAjax.nonce );
			body.append( 'page',     nextPage );
			body.append( 'per_page', perPage );

			try {
				const res  = await fetch( arhikadAjax.ajaxurl, { method: 'POST', body } );
				const data = await res.json();

				if ( data.success ) {
					container.insertAdjacentHTML( 'beforeend', data.data.html );
					btn.dataset.page = nextPage;

					if ( nextPage >= total ) {
						btn.closest( '.load-more-wrapper' ).remove();
					} else {
						btn.disabled    = false;
						btn.textContent = label;
					}
				}
			} catch {
				btn.disabled    = false;
				btn.textContent = label;
			}
		} );
	} );
}
